<span translate>learners-import.drag-message</span>
<button
  pButton
  [label]="'app.browse' | translate"
  icon="fa fa-fw fa-search"
  class="p-button-secondary"
  (click)="onBrowse($event, fileInput)"
></button>
<input #fileInput type="file" accept=".xls,.xlsx" multiple="false" (change)="onFileSelect($event)" hidden />
<small translate>learners-import.types-message</small>
<a href="assets/Learners%20Import%20Template.xlsx" download translate>learners-import.template</a>
